module.exports = __webpack_public_path__ + "static/media/admin_logo.72804540.png";